import Vue from 'vue'
import Vuex from 'vuex'
import swal from 'sweetalert2'
import router from '../router/index'
import { v4 as uuidv4 } from 'uuid'
import moment from "moment"


Vue.use(Vuex)

// realtime firebase
// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

function catchAlert(title, e, type) {
    let msg = ""
    switch (e.code) {
        case "auth/invalid-email":
            msg = "Por favor captura un email válido"
            break
        case "auth/wrong-password":
            msg = "Contraseña inválida"
            break
        case "auth/too-many-requests":
            msg = "Demasiados intentos fallidos, intenta más tarde o recupera tu contraseña"
            break
        case "auth/email-already-in-use":
            msg = "Este correo ya está dado de alta, recupera tu contraseña"
            break
        case "auth/user-not-found":
            msg = "Este usuario no existe en nuestros registros, crea una cuenta"
            break
        default:
            msg = "Hubo un error inesperado, por favor intenta de nuevo"
            break;
    }
    swal.fire(title, msg, type)
}

function sendAlert(title, msg, type) {

    swal.fire(title, msg, type)
}

function custom_sort(a, b) {
    return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
}

const store = new Vuex.Store({
    state: {
        loading: false,
        userProfile: {},
        posts: [],
        ticket: {
            id: null,
            puntos: null,
            time: null,
            time_txt: null,
            ini_time: null,
            fin_time: null
        },
        tickets: [],
        pregs: [],
        miagenda: [],
        slides: ['RETOS-ACTUALES-DE-LA-BANCA', 'Slider_.manejo-de-datosjpg', 'Slider_Autonomus-digital-banking', 'Slider_Bienvenida', 'Slider_Como-ser-global', 'Slider_DATOS-LA-NUEVA-RIQUEZA', 'Slider_Estrategias-para-impulsar-tu-negocio', 'Slider_Extorsion-digital', 'Slider_Impacto-en-las-comunicaciones', 'Slider_Inteligencia-artificial', 'Slider_Las-nuevas-reglas-del-juego', 'Slider_La-transformacion-del-negocio', 'Slider_Lleva-tu-empresa-al-mundo-digital', 'Slider_Lo-que-no-te-contaran', 'Slider_Open-Banking', 'Slider_Todoscompramosenlinea', 'Slider_Verdades-y-mitos'],
        diamante: ['diamante-a3sec', 'diamante-deloitte', 'diamante-discover', 'diamante-fico', 'diamante-google', 'diamante-ingenico', 'diamante-nordstern-ncs', 'diamante-telmex', 'diamante-vierge-tibco', 'diamante-overclockers-cisco'],
        platino: ['platino-aci', 'platino-checkpoint', 'platino-gd', 'platino-glory-kal', 'platino-incode', 'platino-jumio', 'platino-mnemo', 'platino-mycard', 'platino-realsec', 'platino-solopago', 'platino-turing'],
        oro: ['oro_conceptomovil'],
        jade: ['jade-bmc', 'jade-bpgurus', 'jade-copayment', 'jade-thales'],
        qrstands: [

        ],
        conferencias: [{
                "id": "1",
                "nombre": "LOS PAGOS DEL FUTURO",
                "sala": "PLENARIA",
                "horario": "09:05 - 09:20 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "Salvador Espinosa",
                "img_ponente_1": "salvador-espinosa",
                "empresa_ponente_1": "Prosa",
                "logo_ponente_1": "prosa.svg",
                "puesto_ponente_1": "Director General",
                "nombre_ponente_2": "",
                "img_ponente_2": "",
                "empresa_ponente_2": "",
                "logo_ponente_2": "",
                "puesto_ponente_2": "",
                "nombre_ponente_3": "",
                "img_ponente_3": "",
                "empresa_ponente_3": "",
                "logo_ponente_3": "",
                "puesto_ponente_3": "",
                "nombre_ponente_4": "",
                "img_ponente_4": "",
                "empresa_ponente_4": "",
                "logo_ponente_4": "",
                "puesto_ponente_4": "",
                "asistencia": false
            },

            {
                "id": "2",
                "nombre": "INCLUSIÓN FINANCIERA: NEOBANCOS",
                "sala": "PLENARIA",
                "horario": "09:25 - 10:05 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "José Sobrevía",
                "img_ponente_1": "jose-sobrevia",
                "empresa_ponente_1": "Billú",
                "logo_ponente_1": "billu.png",
                "puesto_ponente_1": "Retail Banking & Digital Business Corporate Director",
                "nombre_ponente_2": "Demetrio Strimpopulos",
                "img_ponente_2": "demetrio-strimpopulos",
                "empresa_ponente_2": "Hey Banco",
                "logo_ponente_2": "heybanco.png",
                "puesto_ponente_2": "Chief Design Officer",
                "nombre_ponente_3": "Luis Pineda",
                "img_ponente_3": "luis-pineda",
                "empresa_ponente_3": "Now Bank",
                "logo_ponente_3": "now-negro.png",
                "puesto_ponente_3": "CEO",
                "nombre_ponente_4": "Jeok Cruz",
                "img_ponente_4": "jeok-cruz",
                "empresa_ponente_4": "Prosa",
                "logo_ponente_4": "prosa.svg",
                "puesto_ponente_4": "DGA Comercial y Relación a Clientes",
                "asistencia": false
            },

            {
                "id": "3",
                "nombre": "PANORAMA MACROECONÓMICO",
                "sala": "PLENARIA",
                "horario": "10:10 - 10:50 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "John Price",
                "img_ponente_1": "john-price",
                "empresa_ponente_1": "Payments & Commerce Market Intelligence",
                "logo_ponente_1": "ami.png",
                "puesto_ponente_1": "Managing Director",
                "nombre_ponente_2": "",
                "img_ponente_2": "",
                "empresa_ponente_2": "",
                "logo_ponente_2": "",
                "puesto_ponente_2": "",
                "nombre_ponente_3": "",
                "img_ponente_3": "",
                "empresa_ponente_3": "",
                "logo_ponente_3": "",
                "puesto_ponente_3": "",
                "nombre_ponente_4": "",
                "img_ponente_4": "",
                "empresa_ponente_4": "",
                "logo_ponente_4": "",
                "puesto_ponente_4": "",
                "asistencia": false
            },

            {
                "id": "4",
                "nombre": "AGENTES DE DISRUPCIÓN EN LA INDUSTRIA FINANCIERA",
                "sala": "PLENARIA",
                "horario": "10:55 - 11:15 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "Eduardo Ávalos",
                "img_ponente_1": "eduardo-avalos",
                "empresa_ponente_1": "ACI Worldwide",
                "logo_ponente_1": "aci.png",
                "puesto_ponente_1": "Principal Solution Consultant",
                "nombre_ponente_2": "",
                "img_ponente_2": "",
                "empresa_ponente_2": "",
                "logo_ponente_2": "",
                "puesto_ponente_2": "",
                "nombre_ponente_3": "",
                "img_ponente_3": "",
                "empresa_ponente_3": "",
                "logo_ponente_3": "",
                "puesto_ponente_3": "",
                "nombre_ponente_4": "",
                "img_ponente_4": "",
                "empresa_ponente_4": "",
                "logo_ponente_4": "",
                "puesto_ponente_4": "",
                "asistencia": false
            },

            {
                "id": "5",
                "nombre": "CRECIMIENTO EN LA ACEPTACIÓN DE PAGOS ELECTRÓNICOS",
                "sala": "PLENARIA",
                "horario": "11:40 - 12:20 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "Fabricio Moreno",
                "img_ponente_1": "fabricio-moreno",
                "empresa_ponente_1": "Adyen",
                "logo_ponente_1": "adyen.svg",
                "puesto_ponente_1": "Country Manager",
                "nombre_ponente_3": "Fabián Ferrari",
                "img_ponente_3": "fabian-ferrari",
                "empresa_ponente_3": "Getnet",
                "logo_ponente_3": "getnet.png",
                "puesto_ponente_3": "Director General",
                "nombre_ponente_2": "Myriam Cosío",
                "img_ponente_2": "myriam-cosio",
                "empresa_ponente_2": "ASAMEP",
                "logo_ponente_2": "asamep.png",
                "puesto_ponente_2": "Presidenta",
                "nombre_ponente_4": "Enrique González",
                "img_ponente_4": "enrique-gonzalez",
                "empresa_ponente_4": "Prosa",
                "logo_ponente_4": "prosa.svg",
                "puesto_ponente_4": "Director Comercial Adquirente",
                "asistencia": false
            },

            {
                "id": "6",
                "nombre": "EVOLUCIÓN FINANCIERA: ABORDANDO LOS RETOS DEL MAÑANA",
                "sala": "PLENARIA",
                "horario": "12:30 - 12:50",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "Julio Carranza",
                "img_ponente_1": "julio-carranza",
                "empresa_ponente_1": "ABM",
                "logo_ponente_1": "abm.jpg",
                "puesto_ponente_1": "Presidente",
                "nombre_ponente_2": "",
                "img_ponente_2": "",
                "empresa_ponente_2": "",
                "logo_ponente_2": "",
                "puesto_ponente_2": "",
                "nombre_ponente_3": "",
                "img_ponente_3": "",
                "empresa_ponente_3": "",
                "logo_ponente_3": "",
                "puesto_ponente_3": "",
                "nombre_ponente_4": "",
                "img_ponente_4": "",
                "empresa_ponente_4": "",
                "logo_ponente_4": "",
                "puesto_ponente_4": "",
                "asistencia": false
            },

            {
                "id": "7",
                "nombre": "DESAFIANDO LO TRADICIONAL",
                "sala": "PLENARIA",
                "horario": "12:55 - 13:25 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "Carlos González Fillad",
                "img_ponente_1": "carlos-gonzalez",
                "empresa_ponente_1": "HSBC",
                "logo_ponente_1": "hsbc.svg",
                "puesto_ponente_1": "Managing Director, Regional Head of Global Payments and Cash",
                "nombre_ponente_2": "",
                "img_ponente_2": "",
                "empresa_ponente_2": "",
                "logo_ponente_2": "",
                "puesto_ponente_2": "",
                "nombre_ponente_3": "",
                "img_ponente_3": "",
                "empresa_ponente_3": "",
                "logo_ponente_3": "",
                "puesto_ponente_3": "",
                "nombre_ponente_4": "",
                "img_ponente_4": "",
                "empresa_ponente_4": "",
                "logo_ponente_4": "",
                "puesto_ponente_4": "",
                "asistencia": false
            },


            {
                "id": "8",
                "nombre": "MEDIOS DE PAGO: ¿EVOLUCIÓN O REVOLUCIÓN?",
                "sala": "PLENARIA",
                "horario": "13:30 - 14:10 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_2": "Eduardo Santillán",
                "img_ponente_2": "eduardo-santillan",
                "empresa_ponente_2": "Verifone",
                "logo_ponente_2": "verifone.svg",
                "puesto_ponente_2": "Head of México",
                "nombre_ponente_1": "Héctor Meza",
                "img_ponente_1": "hector-meza",
                "empresa_ponente_1": "Ingenico",
                "logo_ponente_1": "ingenico.svg",
                "puesto_ponente_1": "Country Head México",
                "nombre_ponente_3": "Jonathan Saporta",
                "img_ponente_3": "jonathan-saporta",
                "empresa_ponente_3": "Vierge Group",
                "logo_ponente_3": "vierge.svg",
                "puesto_ponente_3": "Vicepresidente",
                "nombre_ponente_4": "Marcos Linas",
                "img_ponente_4": "marcos-salinas",
                "empresa_ponente_4": "Prosa",
                "logo_ponente_4": "prosa.svg",
                "puesto_ponente_4": "Director Comercial",
                "asistencia": false
            },

            {
                "id": "9",
                "nombre": "LABERINTO TECNOLOGICO: GESTIÓN DE RIESGOS EN LA ERA DIGITAL",
                "sala": "PLENARIA",
                "horario": "14:40 - 15:00 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "Mary Pily Loo",
                "img_ponente_1": "mary-pily-loo",
                "empresa_ponente_1": "CNBV",
                "logo_ponente_1": "cnbv.svg",
                "puesto_ponente_1": "Riesgo Operacional y Tecnológico",
                "nombre_ponente_2": "",
                "img_ponente_2": "",
                "empresa_ponente_2": "",
                "logo_ponente_2": "",
                "puesto_ponente_2": "",
                "nombre_ponente_3": "",
                "img_ponente_3": "",
                "empresa_ponente_3": "",
                "logo_ponente_3": "",
                "puesto_ponente_3": "",
                "nombre_ponente_4": "",
                "img_ponente_4": "",
                "empresa_ponente_4": "",
                "logo_ponente_4": "",
                "puesto_ponente_4": "",
                "asistencia": false
            },

            {
                "id": "10",
                "nombre": "INTELIGENCIA ARTIFICIAL APLICADA A LA CIBERDEFENSA",
                "sala": "PLENARIA",
                "horario": "15:05 - 15:45 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "Marcos Ferreira",
                "img_ponente_1": "marcos-ferreira",
                "empresa_ponente_1": "Crowdstrike",
                "logo_ponente_1": "crowdstrike.svg",
                "puesto_ponente_1": "Director de Ingeniería para Latinoamérica",
                "nombre_ponente_2": "Adriana Armas",
                "img_ponente_2": "adriana-armas",
                "empresa_ponente_2": "Dynatrace",
                "logo_ponente_2": "dynatrace.svg",
                "puesto_ponente_2": "Vicepresidenta América Latina",
                "nombre_ponente_3": "Ulises Castillo",
                "img_ponente_3": "ulises-castillo",
                "empresa_ponente_3": "Scitum",
                "logo_ponente_3": "scitum-telmex.svg",
                "puesto_ponente_3": "Director de Evolución y Aprendizaje de Telmex - Scitum",
                "nombre_ponente_4": "René Agüero",
                "img_ponente_4": "rene-aguero",
                "empresa_ponente_4": "Splunk",
                "logo_ponente_4": "splunk.svg",
                "puesto_ponente_4": "Global Director Security Strategist",
                "nombre_ponente_5": "Sean Cordero",
                "img_ponente_5": "sean-cordero",
                "empresa_ponente_5": "Zscaler",
                "logo_ponente_5": "zscaler.svg",
                "puesto_ponente_5": "Chief Information Security Officer",


                "asistencia": false
            },

            {
                "id": "11",
                "nombre": "COMERCIO ELECTRÓNICO Y PAGOS DIGITALES: UN FUTURO INTERCONECTADO",
                "sala": "PLENARIA",
                "horario": "15:50 - 16:10 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "Othón Moreno González",
                "img_ponente_1": "othon-moreno",
                "empresa_ponente_1": "Banco de México",
                "logo_ponente_1": "banxico.png",
                "puesto_ponente_1": "Director de Política y Estudios de Sistemas de Pagos e Infraestructuras de Mercado",
                "nombre_ponente_2": "",
                "img_ponente_2": "",
                "empresa_ponente_2": "",
                "logo_ponente_2": "",
                "puesto_ponente_2": "",
                "nombre_ponente_3": "",
                "img_ponente_3": "",
                "empresa_ponente_3": "",
                "logo_ponente_3": "",
                "puesto_ponente_3": "",
                "nombre_ponente_4": "",
                "img_ponente_4": "",
                "empresa_ponente_4": "",
                "logo_ponente_4": "",
                "puesto_ponente_4": "",
                "asistencia": false
            },

            {
                "id": "12",
                "nombre": "COMERCIO 2.0: LA TRANSFORMACIÓN DE LOS PAGOS DIGITALES",
                "sala": "PLENARIA",
                "horario": "16:15 - 16:45 ",
                "horarionum": 905,
                "enpalmes": [],
                "duracion": "10",
                "descripcion": ``,
                "nombre_ponente_1": "Christopher Ávila",
                "img_ponente_1": "christopher-avila",
                "empresa_ponente_1": "Google Cloud",
                "logo_ponente_1": "google-cloud.png",
                "puesto_ponente_1": "Transformation and Innovarion Consultant",
                "nombre_ponente_2": "",
                "img_ponente_2": "",
                "empresa_ponente_2": "",
                "logo_ponente_2": "",
                "puesto_ponente_2": "",
                "nombre_ponente_3": "",
                "img_ponente_3": "",
                "empresa_ponente_3": "",
                "logo_ponente_3": "",
                "puesto_ponente_3": "",
                "nombre_ponente_4": "",
                "img_ponente_4": "",
                "empresa_ponente_4": "",
                "logo_ponente_4": "",
                "puesto_ponente_4": "",
                "asistencia": false
            },

        ],
        ponentes: [

            {
                "id": "1",
                "nombre": "Salvador Espinosa",
                "imagen": "Salvador-Espinosa-",
                "puesto": "Director General de",
                "empresa": "Prosa",
                "logo": "prosa.svg",
                "semblanza_larga": `
                <p>Su experiencia profesional en el sistema financiero mexicano supera los 25 años. Salvador ha liderado diversas áreas como cambios y divisas, banca patrimonial e inversiones, implementando estrategias de transformación digital, inclusión financiera y manejo de productos de inversión, así como nómina, préstamos al consumo, tarjetas de crédito, banca móvil y medios de pago.</p>

                <p>Tiene estudios de posgrado en Administración, Finanzas, Mercadotecnia y Dirección General por el Instituto Tecnológico Autónomo de México (ITAM). Participó en el programa de Liderazgo de Duke University en Durham, Carolina del Norte, Estados Unidos.</p>

                <p>Ha formado parte de instituciones como Scotiabank en donde se desempeñó como Vicepresidente de Productos Retail supervisando las siguientes áreas: Captación, Seguros, Tarjeta de Crédito, Préstamos Personales, Nómina, ATM, Débito y Medios de Pago.</p>

                <p>Fue Director General de Crédito Familiar, una SOFOM enfocada en el otorgamiento de préstamos de nómina, créditos al consumo y micronegocios. Desde el 2015 es mentor en Village Capital, una firma de capital de riesgo que encuentra, capacita e invierte en startups de etapa inicial, enfocadas en los sectores agrícola, educativo y energético, así como de inclusión financiera y salud.</p>

                `
            },

            {
                "id": "2",
                "nombre": "Francisco Martha",
                "imagen": "Francisco-Martha",
                "puesto": "Director General de Desarrollo de Negocios Digitales en",
                "empresa": "Banorte",
                "logo": "banorte.svg",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "3",
                "nombre": "Julio Carranza",
                "imagen": "julio",
                "puesto": "Presidente de la",
                "empresa": "Asociación de Bancos de México",
                "logo": "abm.png",
                "semblanza_larga": `

                <p>
                Licenciado en Administración por el Instituto Tecnológico Autónomo de México (ITAM). Cuenta con una trayectoria bancaria de más de 34 años. Se desempeñó en puestos directivos en diversas instituciones, tales como Bancomer (hoy BBVA) y Citibank (hoy Citibanamex). Posteriormente, participó en el diseño, puesta en marcha y operación de 3 nuevos bancos en México: Ixe Banco, Banco Azteca y BanCoppel.
                </p>
                <p>
                En el año 2006 fundó Bancoppel y fue Director General durante 15 años. En el año 2021 fue nombrado Vicepresidente, y en 2022, Presidente del Consejo de Administración. 
                </p>
                <p>
                Su experiencia abarca la banca comercial, banca de consumo, banca patrimonial, banca empresarial, desarrollo de mercados y tecnología de la información con enfoque digital, tanto en México como a nivel internacional.
                </p>
                <p>

                En el ámbito gremial, fue electo Vicepresidente de la Asociación de Bancos de México (ABM) por dos periodos consecutivos: 2019 a 2021 y 2021 a 2023. 
                </p>
                <p>
                En diciembre de 2022, fue electo Presidente de la ABM para el periodo 2023 a 2025. 
                </p>


                `
            },


            {
                "id": "4",
                "nombre": "ALEJANDRO VALENZUELA",
                "imagen": "Alejandro-Valenzuela-",
                "puesto": "Presidente del Consejo de Administración de",
                "empresa": "Banco Azteca",
                "logo": "bancoazteca.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "5",
                "nombre": "Othón Moreno González",
                "imagen": "Othon-Moreno-",
                "puesto": "Director General de Sistemas de Pagos e Infraestructuras de Mercados en",
                "empresa": "Banxico",
                "logo": "banco-de-mexico.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "6",
                "nombre": "Camilo Plazas Michelsen",
                "imagen": "Camilo-Plazas-",
                "puesto": "Presidente de",
                "empresa": "BBDO México",
                "logo": "bbdo.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "7",
                "nombre": "Karen Arroyo Moguel",
                "imagen": "Karen-Arroyo-Moguel",
                "puesto": "Senior New Business Development en",
                "empresa": "ACI Worldwide",
                "logo": "aci.png",
                "semblanza_larga": `
                
                `
            },


            {
                "id": "7",
                "nombre": "Roberto Hernández",
                "imagen": "Roberto-Hernandez",
                "puesto": "CTO en",
                "empresa": "BanBajío",
                "logo": "banbajio.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "8",
                "nombre": "Blanca Ireri Espinosa",
                "imagen": "Blanca-Ireri-",
                "puesto": "CEO en",
                "empresa": "HumanBe",
                "logo": "humanbe.png",
                "semblanza_larga": `
                
                `,
                moderador: 'MODERADORA'
            },
            {
                "id": "9",
                "nombre": "Demetrio Strimpopulos",
                "imagen": "Demetrio-Strimpopulos",
                "puesto": "Chief Design Officer en ",
                "empresa": "Hey Banco",
                "logo": "heybanco.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "10",
                "nombre": "Beatriz Durán Serrano",
                "imagen": "Beatriz-Duran",
                "puesto": "Chief Strategy Officer (CSO) en ",
                "empresa": "Syncfy",
                "logo": "syncfy.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "11",
                "nombre": "Angélica Arana",
                "imagen": "Angelica-Arana",
                "puesto": "CIO en ",
                "empresa": "Multiva",
                "logo": "multiva.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "12",
                "nombre": "Marco Hernández",
                "imagen": "Marco-Hernandez",
                "puesto": "Chief Data Officer en ",
                "empresa": "Prosa",
                "logo": "prosa.png",
                "semblanza_larga": `
                
                `,
                moderador: 'MODERADOR'
            },
            {
                "id": "13",
                "nombre": "Carlos González Fillad",
                "imagen": "Calos-Gonzalez-Fillad",
                "puesto": "Managing Director, Regional Head of Global Payments and Cash Management en",
                "empresa": "HSBC",
                "logo": "hsbc.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "14",
                "nombre": "John Price",
                "imagen": "John-Price",
                "puesto": "Managing Director Payment en",
                "empresa": "PCMI",
                "logo": "pcmi.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "15",
                "nombre": "Jonathan Saporta",
                "imagen": "Jonathan-Saporta",
                "puesto": "VP Latam en",
                "empresa": "Vierge Group",
                "logo": "vierge-group.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "16",
                "nombre": "Armando Campos",
                "imagen": "Armando-Campos",
                "puesto": "Country Manager en",
                "empresa": "Newland",
                "logo": "newland.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "17",
                "nombre": "Héctor Meza",
                "imagen": "Hector-Meza",
                "puesto": "Country Manager en ",
                "empresa": "Ingenico",
                "logo": "ingenico.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "18",
                "nombre": "Enrique González",
                "imagen": "Enrique-Gonzalez",
                "puesto": "Director Comercial Adquirente en ",
                "empresa": "Prosa",
                "logo": "prosa.png",
                "semblanza_larga": `
                
                `,
                moderador: 'MODERADOR'
            },


            {
                "id": "19",
                "nombre": "Laura Rubio",
                "imagen": "Laura",
                "puesto": "Directora de Captación, Tarjetas y Nómina en",
                "empresa": "Banco Azteca",
                "logo": "bancoazteca.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "20",
                "nombre": "Mary Pily Loo",
                "imagen": "Mary-Pily-Loo-",
                "puesto": "Directora General de Riesgo Operacional y Tecnológico en",
                "empresa": "CNBV",
                "logo": "cnbv.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "21",
                "nombre": "Marisol Gutiérrez",
                "imagen": "Marisol-Gutierrez",
                "puesto": "DG Banca de Consumo en",
                "empresa": "Invex",
                "logo": "invex.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "22",
                "nombre": "Arianna Prasio",
                "imagen": "Arianna-Prasio",
                "puesto": "CHRO en",
                "empresa": "Prosa",
                "logo": "prosa.png",
                "semblanza_larga": `
                
                `,
                moderador: 'MODERADORA'
            },

            {
                "id": "23",
                "nombre": "Gustavo Méndez",
                "imagen": "Gustavo-Mendez-",
                "puesto": "Socio de Tecnología y Transformación. Líder de Servicios Financieros en",
                "empresa": "Deloitte Spanish Latin America",
                "logo": "deloitte.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "24",
                "nombre": "Hugo Nájera",
                "imagen": "Hugo-Najera",
                "puesto": "Director General Banca Minorista en",
                "empresa": "BBVA México",
                "logo": "bbva.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "25",
                "nombre": "Eduardo Palacio",
                "imagen": "Eduardo-Palacio",
                "puesto": "Seguridad y Cumplimiento en",
                "empresa": "Google Cloud",
                "logo": "google-cloud.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "26",
                "nombre": "Erika Saucedo",
                "imagen": "Erika-Saucedo",
                "puesto": "Fundadora de",
                "empresa": "Whitesec México",
                "logo": "white-security.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "27",
                "nombre": "Noam Syrkin",
                "imagen": "Noam-Syrkin",
                "puesto": "Senior Technical Product Engineer en",
                "empresa": "Illumio",
                "logo": "illumio.png",
                "semblanza_larga": `
                
                `
            },

            {
                "id": "28",
                "nombre": "Valther Galván",
                "imagen": "Valther-Galvan",
                "puesto": "CISO en",
                "empresa": "Prosa",
                "logo": "prosa.png",
                "semblanza_larga": `
                
                `,
                moderador: 'MODERADOR'
            },





            // {
            //     "id": "11",
            //     "nombre": "José Sobrevía",
            //     "imagen": "jose-sobrevia",
            //     "puesto": "Retail Banking & Digital Business Corporate Director ",
            //     "empresa": "Billú",
            //     "logo": "billu.png",
            //     "semblanza_larga": `
            //     <p>
            //     José Sobrevía es un visionario del sector bancario, reconocido por su capacidad para impulsar la innovación y la venta de productos financieros en un entorno en constante evolución. José ha dejado una huella significativa en la industria bancaria a través de su enfoque creativo y su liderazgo inspirador. Se incorporó al Banco Rio (Santander) en 1988 y en paralelo completó sus estudios de Contaduría y su Licenciatura en Administración en la Universidad de Buenos Aires.
            //     </p>
            //     <p>
            //     Desde el principio, mostró un interés apasionado por la innovación y la búsqueda de nuevas oportunidades de negocio en el mercado financiero.
            //     Ha sido un pionero en la adopción de tecnologías disruptivas y en la creación de productos financieros innovadores que satisfacen las necesidades cambiantes de los clientes. Su visión estratégica y su capacidad para identificar tendencias emergentes han llevado a su institución Banca Afirme a ser reconocida como una líder en el desarrollo de soluciones financieras vanguardistas.                
            //     </p>
            //     <p>
            //     Además de su enfoque en la innovación, José ha sido un defensor de la venta de productos financieros de manera ética y orientada al cliente. Ha implementado programas de capacitación para su equipo de ventas, enfocados en brindar un servicio personalizado y en comprender las necesidades financieras individuales de los clientes.
            //     </p>


            //     `
            // },

            // {
            //     "id": "12",
            //     "nombre": "Demetrio Strimpopulos",
            //     "imagen": "demetrio-strimpopulos",
            //     "puesto": "Chief Design Officer",
            //     "empresa": "Hey Banco",
            //     "logo": "heybanco.png",
            //     "semblanza_larga": `
            //     <p>
            //     Demetrio es el Director de Diseño y Experiencia de Hey Banco y lidera las iniciativas orientadas a crear un modelo de banca digital que simplifique la complejidad de los servicios financieros a través del diseño y aprendizaje de la experiencia del cliente. Demetrio es un activo mentor de la comunidad Fintech en México y ha desarrollado fuertes relaciones con diferentes actores que buscan operar en el sistema financiero mexicano. 
            //     </p>
            //     <p>
            //     Demetrio cuenta con una experiencia bancaria de 32 años y desde entonces ha tenido el privilegio de trabajar en diferentes áreas; como lo son: Tecnología, comercial, canales electrónicos, diseño de productos e Innovación. Ha sido conferencista sobre innovación y tecnología financiera en diferentes países, tiene una Maestría por el Instituto Panamericano de Alta Dirección de Empresa (IPADE) y una Maestría en Desarrollo Humano de la Universidad Iberoamericana.
            //     </p>

            //     `
            // },

            // {
            //     "id": "14",
            //     "nombre": "Luis Pineda",
            //     "imagen": "luis-pineda",
            //     "puesto": "CEO",
            //     "empresa": "Now Bank",
            //     "logo": "now-negro.png",
            //     "semblanza_larga": `
            //     <p>
            //     Luis Pineda actualmente se desempeña como Director de Now Bank, que es el neobanco de INVEX. Dentro de su experiencia profesional, cuenta con más de 15 años en la industria financiera, destacando su anterior rol como Chief Innovation Officer en Invex, que través del modelo de Innovación Dual que hoy utiliza en la organización, dio origen a Now. 
            //     </p>

            //     <p>
            //     Anteriormente, trabajó +10 años en Citi tanto en los corporativos de México como en Nueva York, así como +4 años en American Express, en ambas empresas obteniendo los máximos reconocimientos de innovación y manejo de negocios a nivel mundial. Esto en las divisiones de Banca Digital, Consumo y Banca Corporativa.
            //     </p>

            //     <p>
            //     Luis es Ingeniero Mecánico por el Instituto Tecnológico de Monterrey, cuenta con un MBA en el IPADE y actualmente cursa un segundo MBA ejecutivo en Harvard Business School.
            //     </p>

            //     `
            // },

            // {
            //     "id": "173234",
            //     "nombre": "Jeok Cruz",
            //     "imagen": "jeok-cruz",
            //     "puesto": "DGA Comercial y Relación a Clientes ",
            //     "empresa": "Prosa",
            //     "logo": "prosa.svg",
            //     "semblanza_larga": `
            //     <p>
            //     Tiene más de 25 años de experiencia profesional en el sector financiero. Jeok domina áreas como: gestión de relaciones con clientes de los segmentos de banca minorista y global, ventas consultivas, desarrollo y comercialización de productos de cash management, entre otras.
            //     </p>
            //     <p>
            //     Graduado de la licenciatura en Administración de Empresas con estudios de posgrado en Contabilidad y Finanzas por el Tecnológico de Monterrey; Liderazgo Organizacional por la Universidad Anáhuac y de Alta Dirección en el IPADE.
            //     </p>
            //     <p>
            //     Ha laborado en firmas como HSBC México, Nextel, Banco Azteca y Broxel, donde lideró la creación y ejecución de estrategias comerciales sostenibles para incrementar ingresos, participación de mercado y alcanzar metas a través de la generación de valor a los clientes mediante la satisfacción de sus necesidades.
            //     </p>
            //     `
            // },

            // {
            //     "id": "17",
            //     "nombre": "John Price",
            //     "imagen": "john-price",
            //     "puesto": "Managing Director ",
            //     "empresa": "Payments & Commerce Market Intelligence",
            //     "logo": "ami.png",
            //     "semblanza_larga": `
            //     <p>
            //     John Price es un veterano de la consultoría de mercado de América Latina y uno de los principales oradores públicos y líderes de opinión de la región.
            //     </p>
            //     <p>
            //     John ha asesorado a más de 100 de los inversores estratégicos más grandes del mundo en América Latina en el transcurso de 30 años. La carrera de consultoría de John comenzó en México, donde fundó InfoAmericas, convirtiéndose en la firma independiente de inteligencia de mercado más grande de América Latina. La empresa se vendió en 2007 a Kroll, donde John lanzó la primera práctica de inteligencia de mercado de Kroll. En 2011, John dejó Kroll y fundó Americas Market Intelligence con sede en Miami y oficinas satélite en Ciudad de México, Buenos Aires, Sao Paulo, Santiago, Medellín y San Francisco.
            //     </p>
            //     <p>
            //     John ha publicado más de 200 artículos sobre tendencias comerciales en América Latina y mantiene una columna en Latin Trade. En 2007, John Price coescribió y coeditó “Can Latin America Compete?”, que fue publicado por Palgrave. John enseña como profesor adjunto en la Universidad Internacional de Florida y profesor invitado en la Universidad de Miami.
            //     </p>
            //     `
            // },

            // {
            //     "id": "8345",
            //     "nombre": "Eduardo Ávalos",
            //     "imagen": "eduardo-avalos",
            //     "puesto": "Principal Solution Consultant",
            //     "empresa": "ACI Worldwide",
            //     "logo": "aci.png",
            //     "semblanza_larga": `
            //     Eduardo Ávalos Maldonado, Principal Solution Consultant en ACI Worldwide, es licenciado en Sistemas de Computación Administrativa, con un MBA enfocado en la creación de Nuevas Empresas por parte del Tec de Monterrey. Eduardo cuenta con más de 25 años de experiencia en la industria de pagos, enfocado principalmente en la mejora de procesos comerciales.
            //     `
            // },

            // {
            //     "id": "18",
            //     "nombre": "Fabricio Moreno",
            //     "imagen": "fabricio-moreno",
            //     "puesto": "Country Manager",
            //     "empresa": "Adyen ",
            //     "logo": "adyen.svg",
            //     "semblanza_larga": `
            //    <p>
            //     Fue promovido como Country Manager de Adyen México en enero de 2023, siendo responsable de la operación y expansión de la plataforma de pagos en el país, al igual que del fortalecimiento y posicionamiento de la empresa en México.
            //     </p>
            //     <p>
            //     Entre los principales objetivos de Fabricio en esta posición, destaca la digitalización e impulsar la innovación en el ecosistema de pagos para las empresas del país.
            //     Fabricio ha trabajado en Adyen por casi ocho años, principalmente en el área comercial, donde inició como Gerente de Ventas para América Latina en 2015. Asimismo, fue vicepresidente de Ventas y nombrado Head de Ventas para LatAm en 2018. En su rol, al frente del equipo comercial en Brasil, ayudó a los grandes minoristas y a empresas de comercio electrónico a ofrecer la mejor experiencia de pago a sus clientes.
            //     Cuenta con un amplio conocimiento del ecosistema en la región, lo que le permite tener una gran visión sobre las necesidades particulares del procesamiento de pagos en México, y ayudar a las empresas del país a alcanzar un nivel de innovación en tecnología de pagos.
            //     Su carrera profesional incluye también 13 años de experiencia como emprendedor en diversos sectores como retail, construcción y tecnología.
            //     </p>
            //     <p>
            //     Originario de Brasil, Fabricio es Ingeniero por el Instituto Mauá de Tecnologia y cuenta con un MBA en Comercio Exterior y Negocios Internacionales por la Fundação Getúlio Vargas.
            //     </p>


            //     `
            // },

            // {
            //     "id": "199087",
            //     "nombre": "Myriam Cosío Robles",
            //     "imagen": "myriam-cosio",
            //     "puesto": "Presidenta",
            //     "empresa": "ASAMEP",
            //     "logo": "asamep.png",
            //     "semblanza_larga": `
            //     <p>
            //     Myriam Cosío es Chief External Affairs Officer, cargo que ocupa desde 2021, y también pertenece al consejo de administración de Clip. Myriam se unió a Clip en 2015 como Chief Operations Officer y, más recientemente, encabezó el área de Servicios Financieros.
            //     </p>
            //     <p>
            //     Antes de unirse a Clip, Myriam Cosío trabajó en American Express durante 11 años y ocupó varios puestos de liderazgo, incluida la vicepresidencia de gestión de clientes y desarrollo de productos.
            //     </p>
            //     <p>
            //     Es Licenciada en Ingeniería en Sistemas Electrónicos y Eléctricos por la Universidad Anáhuac de México y cuenta con una Maestría en Administración de Negocios por el Instituto Tecnológico Autónomo de México (ITAM).
            //     </p>
            //     <p>
            //     A partir de 2022 se sumó como Mentora Endeavor y ha sido reconocida en múltiples ocasiones dentro de la lista de 500 personas más influyentes de AL  seleccionadas por Bloomberg Line. 
            //     </p>
            //     <p>
            //     Desde 2022 es miembro del Consejo de la Asociación de Agregadores de Medios de Pago (ASAMEP) de México y en mayo de 2023 fue electa, por un período de 2 años, como Presidenta de dicha Asociación. En abril del mismo año fue nombrada Vicepresidenta de Competencia de la Asociación Fintech México. 
            //     </p>
            //     <p>
            //     Su trayectoria profesional ha consolidado a Myriam como líder y referente en el sector de servicios financieros, específicamente en lo relacionado con medios de pago. 
            //     </p>

            //     `
            // },

            // {
            //     "id": "19234234",
            //     "nombre": "Fabián Ferrari",
            //     "imagen": "fabian-ferrari",
            //     "puesto": "Director General",
            //     "empresa": "Getnet",
            //     "logo": "getnet.png",
            //     "semblanza_larga": `
            //     <p>
            //     Licenciado en Economía por el ITAM. Actualmente Director General de Getnet México, la segunda empresa adquirente más grande de México por número de clientes, volumen y transacciones.
            //     </p>
            //     <p>
            //     Cuenta con más de 20 años de experiencia bancaria, iniciando su carrera en el banco Citibanamex, donde participó en áreas de Gobierno y Crédito por 4 años. Posteriormente, fue parte de Banco Santander durante 12 años, con una carrera exitosa liderando áreas comerciales y responsable de proyectos de diferentes servicios, como nómina, grandes cuentas, adquirente, banca corporativa y minorista, siendo su última actividad en el banco como Director de Banca Comercial e Institucional. 
            //     </p>
            //     <p>
            //     A partir de 2017 y hasta la fecha, lidera el negocio adquirente en lo que fue Elavon y posterior a la adquisición por PagoNxt, parte de Grupo Global Santander, Getnet México que, además, forma parte de una marca con presencia en Latinoamérica & Europa. Getnet ha logrado posicionarse como la tercera empresa más grande por número de clientes y volumen de Latam, con presencia en Brasil, México, Chile, Argentina y Uruguay, siendo México una de las principales dos geografías en relevancia por contribución a los resultados de PagoNxt.
            //     </p>
            //     <p>
            //     Durante 2022, obtuvo el premio a la categoría “Payments and Wallets Innovation” en los Premios a los Innovadores Financieros en las Américas realizadas por Fintech Américas, esto, como resultado de ser la primera empresa adquirente en lograr la incursión de pagos abiertos en el segundo transporte público más importante del país, Metrobús y donde se transportan cerca de 1.8 millones de pasajeros al día.
            //     </p>

            //     `
            // },



            // {
            //     "id": "19",
            //     "nombre": "Enrique González",
            //     "imagen": "enrique-gonzalez",
            //     "puesto": "Director Comercial Adquirente",
            //     "empresa": "Prosa",
            //     "logo": "prosa.svg",
            //     "semblanza_larga": `
            //     <p>
            //     Tiene más de 25 años de experiencia profesional en el sector financiero. Enrique ha estado a cargo de la gestión, diseño y administración de productos, operaciones bancarias, manejo de riesgos como fraudes e investigaciones de crimen financiero. 
            //     </p>
            //     <p>
            //     Graduado de la licenciatura en Contaduría y Administración de Empresas con estudios de posgrado en Leadership Essentials por el IPADE; Desarrollo de Competencias Gerenciales por el Tecnológico de Monterrey y Coaching Team Management and Senior Leadership por la Global HSBC University.
            //     </p>
            //     <p>
            //     La mayor parte de su carrera profesional la desarrolló en HSBC México donde lideró equipos en áreas como: Tarjetas de Acceso a Depósitos y Tarjetas de Débito, Desarrollo de Producto y Negocio Adquirente, Medios Electrónicos, Riesgo Reputacional, Selección de Clientes y Administración de Salidas y Retenciones.
            //     </p>
            //     <p>
            //     Desde hace poco más de 4 años, lidera el posicionamiento y aceptación de la marca Carnet, así como la integración de nuevos negocios y clientes de los segmentos Adquirente y Emisor al Ecosistema de Pagos.
            //     </p>


            //     `
            // },


            // {
            //     "id": "2",
            //     "nombre": "Julio Carranza",
            //     "imagen": "julio-carranza",
            //     "puesto": "Presidente",
            //     "empresa": "ABM",
            //     "logo": "abm.png",
            //     "semblanza_larga": `

            //     <p>
            //     Licenciado en Administración por el Instituto Tecnológico Autónomo de México (ITAM). Cuenta con una trayectoria bancaria de más de 34 años. Se desempeñó en puestos directivos en diversas instituciones, tales como Bancomer (hoy BBVA) y Citibank (hoy Citibanamex). Posteriormente, participó en el diseño, puesta en marcha y operación de 3 nuevos bancos en México: Ixe Banco, Banco Azteca y BanCoppel.
            //     </p>
            //     <p>
            //     En el año 2006 fundó Bancoppel y fue Director General durante 15 años. En el año 2021 fue nombrado Vicepresidente, y en 2022, Presidente del Consejo de Administración. 
            //     </p>
            //     <p>
            //     Su experiencia abarca la banca comercial, banca de consumo, banca patrimonial, banca empresarial, desarrollo de mercados y tecnología de la información con enfoque digital, tanto en México como a nivel internacional.
            //     </p>
            //     <p>

            //     En el ámbito gremial, fue electo Vicepresidente de la Asociación de Bancos de México (ABM) por dos periodos consecutivos: 2019 a 2021 y 2021 a 2023. 
            //     </p>
            //     <p>
            //     En diciembre de 2022, fue electo Presidente de la ABM para el periodo 2023 a 2025. 
            //     </p>


            //     `
            // },

            // {
            //     "id": "15",
            //     "nombre": "Carlos González Fillad",
            //     "imagen": "carlos-gonzalez",
            //     "puesto": "Managing Director, Regional Head of Global Payments and Cash",
            //     "empresa": "HSBC",
            //     "logo": "hsbc.svg",
            //     "semblanza_larga": `
            //     <p>
            //     Carlos Gonzalez Fillad es el Director Ejecutivo Regional para Banca Transaccional, Banca Digital y Liquidez de HSBC para México y Latinoamérica – Global Liquidity and Cash Management “GLCM” por sus siglas en ingles. Es miembro permanente del Comité Ejecutivo Global de Banca Transaccional, Banca Digital y Liquidez de HSBC Holdings. También es miembro permanente del Comité Ejecutivo de HSBC en Latinoamérica. 
            //     </p>
            //     <p>
            //     Desde su rol actual, es responsable de las plataformas digitales, los sistemas de pagos, los productos de manejo de tesorería y el manejo de la liquidez de las divisiones mayoristas. Asimismo, es responsable de los sistemas de pagos regulatorios y el cumplimiento de los estándares globales en ciberseguridad y prevención y lavado de dinero. En adición, es responsable del desarrollo comercial y servicio post venta de la Banca Transaccional en HSBC.
            //     </p>
            //     <p>
            //     Cuenta con una extensa trayectoria dentro de HSBC, habiendo manejado en su carrera los principales portafolios de clientes de la banca mayorista. Ha sido responsable de diversos sectores como el siderúrgico, industrial, consumo, autos, entre otros, liderando el desarrollo de transacciones clave en fusiones y adquisiciones, mercado de deuda, crédito sindicados, entre otros. 
            //     </p>
            //     <p>
            //     Carlos es miembro titular del Consejo Consultivo de Pagos de Banco de México, miembro fundador del Consejo de Expertos en Regulación y Ciberseguridad de México y miembro del Instituto de Ejecutivos en Finanzas de México. Es egresado de la Universidad Iberoamericana en Administración de Empresas y cuenta con una Maestría en Administración de Empresas por parte del ITAM. Adicionalmente, cuenta con diversos diplomas y certificaciones globales en materia de crédito, banca y ciberseguridad. 
            //     </p>

            //     `
            // },

            // {
            //     "id": "4",
            //     "nombre": "Héctor Meza",
            //     "imagen": "hector-meza",
            //     "puesto": "Country Head México",
            //     "empresa": "Ingenico",
            //     "logo": "ingenico.svg",
            //     "semblanza_larga": `

            //     <p>
            //     Héctor cuenta con más de 30 años de experiencia en ventas, operaciones y cadena de suministro, con un robusto historial, ofreciendo soluciones de negocios de clase mundial, dentro de varias instituciones de la industria de tecnología.
            //     </p>
            //     <p>
            //     Antes de unirse a Ingenico, Meza trabajó para Oracle, Microsoft e IBM, en donde se desempeñó en una variedad de roles dentro de estas compañías, supervisando el desarrollo y comercialización de la estrategia de negocios en la nube para la región de América Latina, así como para las filiales mexicanas. Ha formado parte de la junta de innovación, así como del equipo fintech y embajadores de start-ups. 
            //     </p>
            //     <p>
            //     Participó junto con el gobierno de la CDMX en proyectos como el Hackathon para apoyar a la juventud mexicana a desarrollar proyectos para el beneficio de la sociedad mexicana. Se ha desempeñado en las industrias financiera, retail, y sector público de energía, cerrando varios contratos clave y supervisando el P&amp;L para sus equipos y empresas. Es también parte del consejo directivo de Ingenico, y copropietario de una empresa de R&amp;P.
            //     </p>

            //     `
            // },

            // {
            //     "id": "3",
            //     "nombre": "Eduardo Santillán",
            //     "imagen": "eduardo-santillan",
            //     "puesto": "Head of México",
            //     "empresa": "Verifone",
            //     "logo": "verifone.svg",
            //     "semblanza_larga": `
            //     Cuenta con 33 años de experiencia en el sector financiero, banca, medios de pagos, comercio electrónico, tecnología y telecomunicaciones. Ha liderado las estrategias comerciales, de marketing, productos y servicio al cliente de grandes empresas, pymes y gobiernos. Actualmente dirige las operaciones de Verifone en el mercado mexicano y es responsable de la estrategia de negocios y comercial de los distintos clientes.
            //     `
            // },

            // {
            //     "id": "5",
            //     "nombre": "Jonathan Saporta",
            //     "imagen": "jonathan-saporta",
            //     "puesto": "Vicepresidente",
            //     "empresa": "Vierge Group",
            //     "logo": "vierge.svg",
            //     "semblanza_larga": `
            //     Con más de 20 años de experiencia, Saporta es un experto en temas de innovación, desarrollo de soluciones tecnológicas, biometría y transformación digital. Desde su posición actual en Vierge Group acompaña a sus clientes a encontrar la mejor solución en medios de pago al menor costo posible.
            //     `
            // },

            // {
            //     "id": "192424335",
            //     "nombre": "Marcos Linas",
            //     "imagen": "marcos-salinas",
            //     "puesto": "Director Comercial",
            //     "empresa": "Prosa",
            //     "logo": "prosa.svg",
            //     "semblanza_larga": `
            //     <p>
            //     Cuenta con más de 25 años de experiencia en medios de pago, negocio adquirente y tarjetas bancarias. Marcos ha liderado la creación de las áreas responsables del negocio adquirente, así como la colocación y afiliación de comercios, servicios al cliente y áreas operativas.
            //     </p>
            //     <p>
            //     Es Ingeniero Industrial por la Unidad Profesional Interdisciplinaria de Ingeniería y Ciencias Sociales y Administrativas. Cuenta con una maestría en Administración y Gestión de Empresas por la Universidad del Valle de México.
            //     </p>
            //     <p>
            //     Ha creado nuevos productos de tarjetas bancarias, soluciones para el desarrollo de nuevas tecnologías en Terminales Punto de Venta para diversos bancos en México.
            //     </p>
            //     <p>
            //     Previo a su ingreso a Prosa, colaboró en HSBC, Intercam Banco e Ingenico, actualmente se desempeña como Director de Estrategia Comercial.
            //     </p>


            //     `
            // },

            // {
            //     "id": "19234324",
            //     "nombre": "Mary Pily Loo",
            //     "imagen": "mary-pily-loo",
            //     "puesto": "Riesgo Operacional y Tecnológico ",
            //     "empresa": "CNBV",
            //     "logo": "cnbv.svg",
            //     "semblanza_larga": `
            //     <p>
            //     Mary Pily cuenta con más de 15 años de trayectoria profesional en el sector financiero y de gobierno, con experiencia en sistemas, medios de pago, agregadores y continuidad del negocio. 
            //     </p>
            //     <p>
            //     En la CNBV está a cargo de la supervisión de Riesgo Operacional y Tecnológico de las Entidades Financieras.
            //     </p>
            //     <p>
            //     También ha participado en proyectos de regulación basados en nuevas tecnologías como la Ley de Instituciones de Tecnología Financiera, Participantes en Redes de Medios de Disposición, Contratación no presencial y Seguridad de la información.
            //     </p>


            //     `
            // },
            // {
            //     "id": "6345",
            //     "nombre": "Marcos Ferreira",
            //     "imagen": "marcos-ferreira",
            //     "puesto": "Director de Ingeniería para Latinoamérica ",
            //     "empresa": "Crowdstrike ",
            //     "logo": "crowdstrike.svg",
            //     "semblanza_larga": `
            //     <p>
            //     Marcos Ferreira trabaja en el área de tecnología de la información hace más de 15 años, con más de 10 años de experiencia en seguridad de la información. Ha desempeñado funciones en las áreas de capacitación, soporte, servicios y preventa de diferentes fabricantes del sector. 
            //     </p>
            //     <p>
            //     Actualmente, es responsable del área de ingeniería para la región Latino America en CrowdStrike. 

            //     </p>
            //     <p>
            //     Con pregrado en la PUC-SP y posgrado en Administración y Gestión de Empresas de la FGV, Marcos es un profesional enfocado en los negocios y un entusiasta de la seguridad, habiendo obtenido varios certificados del sector a lo largo de su carrera.
            //     </p>
            //     `
            // },
            // {
            //     "id": "6",
            //     "nombre": "Adriana Armas",
            //     "imagen": "adriana-armas",
            //     "puesto": "Vicepresidenta América Latina",
            //     "empresa": "Dynatrace",
            //     "logo": "dynatrace.svg",
            //     "semblanza_larga": `
            //     <p>
            //     Adriana Armas estudió en el Tecnológico de Monterrey Campus Ciudad de México y actualmente estudia un MBA en Information technology con una especialidad en ciberseguridad en dicha institución. 
            //     </p>
            //     <p>
            //     Adriana a lo largo de su carrera ha estudiado en diferentes lugares del mundo como por ejemplo Italia, Francia, Canadá, Australia entre otros. En su carrera profesional ha desarrollado diferentes clientes en la región de Latinoamérica y Europa siendo la industria financiera, energía y de retail las principales. 
            //     </p>

            //     <p>
            //     Durante los últimos años ha estado desempeñando diferentes puestos directivos en las empresas dedicadas a la ciberseguridad, inteligencia artificial y software.
            //     </p>

            //     `
            // },
            // {
            //     "id": "9784879433",
            //     "nombre": "Ulises Castillo",
            //     "imagen": "ulises-castillo",
            //     "puesto": "Director de Evolución y Aprendizaje de Telmex - Scitum",
            //     "empresa": "Scitum",
            //     "logo": "scitum-telmex.svg",
            //     "semblanza_larga": `
            //     <p>
            //     Es Egresado de la Facultad de Ingeniería de la Universidad La Salle, así como de la Maestría en Ciberseguridad de la Universidad de Norwich, EUA y de la Maestría en Liderazgo Positivo de la Universidad Tec Milenio, habiendo obtenido Mención Honorífica en las 3 instituciones.
            //     </p>
            //     <p>
            //     Se inició en la informática en 1977 y desde 1980 ha fundado diversas empresas entre las que destacan: Comper, Grupo Scanda y Scitum, en donde fue director general hasta 2019 y actualmente es director de Evolución y Aprendizaje.
            //     </p>
            //     <p>

            //     Posee las certificaciones CISSP (de ISC2), CISA y CISM (de ISACA) y GSTRT (del SANS Institute). De 1979 a 1998 fue profesor de diversas asignaturas en la carrera de Ingeniería Cibernética en la Universidad La Salle, de 2017 a 2020 fue profesor de la Maestría en Ciberseguridad de la misma Universidad y a partir de 2020, profesor de la Maestría en Ciberseguridad del Tecnológica de Monterrey.
            //     </p>
            //     <p>
            //     Ha sido expositor en México, Latinoamérica y Estados Unidos, de diversos talleres y cursos alrededor de la informática desde hace más de 40 años, y en los últimos 25 años enfocándose a los temas de ciberseguridad. En los últimos años, ha completado su formación estudiando sobre psicología positiva, comunicación efectiva, cerebro y aprendizaje, procesos creativos y liderazgo. Posee la certificación como facilitador en Solución Creativa de Problemas (CPS por sus siglas en inglés) otorgado por la Buffalo State University, New York.

            //     </p>


            //     `
            // },



            // {
            //     "id": "6346",
            //     "nombre": "René Agüero",
            //     "imagen": "rene-aguero",
            //     "puesto": "Global Director Security Strategist",
            //     "empresa": "Splunk ",
            //     "logo": "splunk.svg",
            //     "semblanza_larga": `
            //     <p>
            //     René ha ayudado a solidificar el lugar de Splunk entre los proveedores líderes de seguridad cibernética al realizar más de 100 evaluaciones de seguridad, liderar equipos globales y ayudar a los clientes a resolver sus problemas de seguridad más desafiantes. 
            //     </p>
            //     <p>
            //     Antes de Splink, estuvo en Rapid7, donde ayudó a GTM con implementaciones y servicios que van desde la gestión de vulnerabilidades, pruebas de penetración y UBA. Antes de Rapid7, René trabajó en el sector financiero en el sur de California como gerente de seguridad, donde ganó premios por el programa de seguridad que desarrolló. 
            //     </p>
            //     <p>
            //     René realizó una Maestría en Ciencias en Administración de Empresas con énfasis en Seguridad de TI, Auditoría de TI e informática forense de la Universidad Politécnica de California en Pomona. René ha aparecido en Associated Press y sus agencias de noticias asociadas sobre temas como End of XP y Anthem Healthcare Breach.
            //     </p>

            //     `
            // },
            // {
            //     "id": "6347",
            //     "nombre": "Sean Cordero",
            //     "imagen": "sean-cordero",
            //     "puesto": "Chief Information Security Officer",
            //     "empresa": "Zscaler",
            //     "logo": "zscaler.svg",
            //     "semblanza_larga": `
            //     <p>
            //     Sean Cordero cuenta con más de 20 años de experiencia en seguridad de la información y liderazgo en su rol como CISO para LATAM en Zscaler, la empresa líder en seguridad en la nube y cero confianza. Como un ejecutivo de seguridad con experiencia y asesor para el Global 100, Cordero impulsa cambios a nivel de industria en la gestión de riesgos de la información, seguridad en la nube y liderazgo. En este cargo, Cordero trabaja en conjunto con ejecutivos de seguridad y líderes de pensamiento de la industria para desarrollar estrategias empresariales y de gestión de riesgos necesarias para respaldar a las empresas que han pasado por una transformación digital y los nuevos riesgos cibernéticos a los que se enfrentan.
            //     </p>

            //     `
            // },



            // {
            //     "id": "97848794",
            //     "nombre": "Othón Moreno",
            //     "imagen": "othon-moreno",
            //     "puesto": "Director de Política y Estudios de Sistemas de Pagos e Infraestructuras de Mercado",
            //     "empresa": "Banco de México",
            //     "logo": "banxico.png",
            //     "semblanza_larga": `
            //     <p>
            //     Othón Moreno es Director de Política y Estudios de Sistemas de Pagos e Infraestructuras de Mercados en el Banco de México. Es doctor en Economía por la Universidad de Texas, Austin y licenciado en Economía por el Instituto Tecnológico y de Estudios Superiores de Monterrey, Campus Estado de México. 
            //     </p>
            //     <p>
            //     Ha desarrollado su carrera profesional en el Banco de México, donde estuvo a cargo del área de compilación y análisis de estadística financiera, en la Dirección de Análisis Macroeconómico, y fungió como Gerente de Estudios de los Sistemas de Pagos así como Gerente de Política y Vigilancia de los Sistemas de Pagos en la Dirección de Sistemas de Pagos.
            //     </p>
            //     <p>
            //     Actualmente, sus labores están relacionadas con el desarrollo de políticas y regulaciones aplicables a las infraestructuras de los mercados financieros.
            //     </p>

            //     <p>
            //      En su puesto actual ha sido responsable de coordinar la elaboración de diversos proyectos regulatorios enfocados a procurar el correcto funcionamiento de los sistemas de pagos y otras infraestructuras de los mercados financieros en México y ha colaborado con otras autoridades para fomentar la incorporación de nuevos participantes en el mercado de pagos al menudeo.
            //     </p>


            //     `
            // },



            // {
            //     "id": "10",
            //     "nombre": "Christopher Ávila",
            //     "imagen": "christopher-avila",
            //     "puesto": "Transformation and Innovarion Consultant",
            //     "empresa": "Google Cloud",
            //     "logo": "google-cloud.png",
            //     "semblanza_larga": `
            //     <p>
            //     Me encanta leer, aprender, caminar, tomar café y viajar. Mi película favorita es Interestelar. Mis 3 ciudades favoritas son CDMX, San Francisco y Helsinki. Aprendiz de por vida. Creador de cambios, Solucionador de problemas. Apasionado de la Transformación Cultural y Digital, Tecnología (Datos, AI/ML, Web3), Diseño, Empresa, Creatividad e Innovación. Fortalezas de Clifton: Aprendiz, Triunfador, Enfocado, Analítico, Futurista.
            //     </p>
            //     <p>
            //     Consultor con más de 20 años de experiencia.  Transformation & Innovation Lead, Google Cloud LATAM. Ayudando a las Organizaciones en LATAM a prosperar en la Transformación Digital. Ex ingeniero de ventas senior, Former Senior Sales Engineer, Senior Solutions Architect and Consultant en empresas como Ericsson, BroadSoft, AWS y Google.
            //     </p>
            //     <p>
            //     Estudios Académicos en la UNAM, ITAM, (México) y Universidad del Alto (Helsinki) Capacitación digital en MIT, Columbia y Berkeley y más. de Seth Godin AltMBA, entrenador certificado High Flow de Steven Kotler, Singularity University Programa Ejecutivo, Embajador Global de Singularity University.
            //     </p>

            //     `
            // },











        ]
    },
    getters: {
        ticketID(state) {
            state.ticket.id = localStorage.getItem('id_ultimo_ticket')
            return state.ticket.id
        },
        timeInit(state) {
            state.ticket.ini_time = localStorage.getItem('ticket_ini_time')
            return state.ticket.ini_time
        },
        pregs(state) {
            state.pregs = JSON.parse(localStorage.getItem('pregs'))
            return state.pregs
        }
    },
    mutations: {
        showLoader(state, val) {
            state.loading = val
        },
        setUserProfile(state, val) {
            state.userProfile = val
        },
        setPerformingRequest(state, val) {
            state.performingRequest = val
        },
        setPosts(state, val) {
            state.posts = val
        },
        setTicketID(state, val) {
            localStorage.setItem('id_ultimo_ticket', val)
            state.ticket.id = val
        },
        setTimeInit(state, val) {
            if (localStorage.getItem('ticket_ini_time') == null || localStorage.getItem('ticket_ini_time') == '') {
                localStorage.setItem('ticket_ini_time', val)
                state.ticket.ini_time = val
            }
        },
        removeTimeInit(state, val = null) {
            localStorage.setItem('ticket_ini_time', '')
            localStorage.setItem('pregs', '')
            state.ticket.ini_time = ''
        },
        setTicket(state, data) {
            state.ticket.puntos = data.puntos
            state.ticket.time = data.time
            state.ticket.time_txt = data.time_txt
        },
        setTickets(state, data) {
            console.log('setting tickets')
            state.tickets = data
        },
        setPregs(state, data) {
            if (localStorage.getItem('pregs') == null || localStorage.getItem('pregs') == '') {
                localStorage.setItem('pregs', JSON.stringify(data))
                state.pregs = data
            }
        }
    },
    actions: {
        async login({ dispatch }, form) {
            // // sign user in

            // dispatch('showLoader', true)
            // let user = {};

            // try {
            //     user = await fb.auth.signInWithEmailAndPassword(form.email, form.password)
            //     console.log(user.user)
            // } catch (e) {
            //     console.log({ e: e })
            //     catchAlert('Oops', e, 'warning')
            // }

            // dispatch('showLoader', false)

            // if (Object.keys(user.user).length === 0 && user.user.constructor === Object)
            //     return

            // //valida verificacion correo
            // // // // console.log({ verified: user.user.emailVerified })
            // // // // if (user.user.emailVerified == false) {
            // // // //     sendAlert('Verifica tu correo', 'Aún no has verificado tu correo, ingresa al buzón del correo registrado y da clic en la liga de verificación.', 'warning')
            // // // //     return
            // // // // }


            // // fetch user profile and set in state
            // dispatch('fetchUserProfile', user.user)

            // router.push('/')
        },
        async loginReportes({ dispatch }, form) {




        },
        async signup({ dispatch, commit }, form) {
            // // sign user up
            // dispatch('showLoader', true)
            // let user = {}
            // try {
            //     user = await fb.auth.createUserWithEmailAndPassword(form.email, form.password)
            //     console.log(user.user)
            // } catch (e) {
            //     console.log({ e: e })
            //     catchAlert('Oops', e, 'warning')
            //     dispatch('showLoader', false)
            // }


            // if (Object.keys(user.user).length === 0 && user.user.constructor === Object)
            //     return

            // // create user object in userCollections


            // await fb.usersCollection.doc(user.user.uid).set({
            //     nombre: form.nombre,
            //     apellido: form.apellido,
            //     celular: form.celular,
            //     email: user.user.email,
            //     fecha_nacimiento: form.fecha_nacimiento,
            //     updated_at: ''
            // })

            // //user.user.sendEmailVerification();

            // // //commit('setUserProfile', {})
            // // await fb.auth.signOut()
            // dispatch("logout");
            // // // clear user data from state
            // // commit('setUserProfile', {})

            // sendAlert('¡Bien!', 'Hemos enviado un correo de verificación a la cuenta ' + form.email, 'success')
            // dispatch('showLoader', false)

            // // fetch user profile and set in state
            // //dispatch('fetchUserProfile', user.user)
        },
        async registroMonedero({ dispatch, commit }, monedero) {
            // // sign user up
            // dispatch('showLoader', true)

            // const userId = fb.auth.currentUser.uid

            // await fb.usersCollection.doc(userId).update({
            //     monedero: monedero,
            //     updated_at: new Date()
            // })


            // dispatch('fetchUserProfile', { uid: userId })

            // dispatch('showLoader', false)

            // sendAlert('¡Bien!', 'Se ha registrado correctamente tu monedero.', 'success')
            //     // fetch user profile and set in state
            //     //dispatch('fetchUserProfile', user.user)
        },
        async fetchUserProfile({ commit }, user) {
            // // fetch user profile
            // const userProfile = await fb.usersCollection.doc(user.uid).get()
            //     //console.log({ user: userProfile.data() })
            //     // set user profile in state
            // commit('setUserProfile', userProfile.data())

            // // change route to dashboard

            // // if (router.currentRoute.path === '/login') {
            // //     router.push('/')
            // // }
        },
        async logout({ commit }) {
            // log user out


            // clear user data from state
            //commit('setUserProfile', {})
            localStorage.removeItem('user_foroprosa_2023');

            // redirect to login view
            router.push('/administrador/')
        },
        async logoutUsuario({ commit }) {
            // log user out


            // clear user data from state
            //commit('setUserProfile', {})
            localStorage.removeItem('user_foroprosa_2023');
            localStorage.removeItem('user_foroprosa_2023_lector');

            // redirect to login view
            router.push('/')
            window.location.reload();
        },
        async logout_lector({ commit }) {
            // log user out


            // clear user data from state
            //commit('setUserProfile', {})
            localStorage.removeItem('user_foroprosa_2023_lector');

            // redirect to login view
            router.push('/lector/')
        },
        async createPost({ state, commit }, post) {
            // // create post in firebase
            // await fb.postsCollection.add({
            //     createdOn: new Date(),
            //     content: post.content,
            //     userId: fb.auth.currentUser.uid,
            //     userName: state.userProfile.name,
            //     comments: 0,
            //     likes: 0
            // })
        },
        async likePost({ commit }, post) {
            // const userId = fb.auth.currentUser.uid
            // const docId = `${userId}_${post.id}`

            // // check if user has liked post
            // const doc = await fb.likesCollection.doc(docId).get()
            // if (doc.exists) { return }

            // // create post
            // await fb.likesCollection.doc(docId).set({
            //     postId: post.id,
            //     userId: userId
            // })

            // // update post likes count
            // fb.postsCollection.doc(post.id).update({
            //     likes: post.likesCount + 1
            // })
        },
        async updateProfile({ dispatch }, user) {
            // const userId = fb.auth.currentUser.uid
            //     // update user object
            // const userRef = await fb.usersCollection.doc(userId).update({
            //     name: user.name,
            //     title: user.title
            // })

            // dispatch('fetchUserProfile', { uid: userId })

            // // update all posts by user
            // const postDocs = await fb.postsCollection.where('userId', '==', userId).get()
            // postDocs.forEach(doc => {
            //     fb.postsCollection.doc(doc.id).update({
            //         userName: user.name
            //     })
            // })

            // // update all comments by user
            // const commentDocs = await fb.commentsCollection.where('userId', '==', userId).get()
            // commentDocs.forEach(doc => {
            //     fb.commentsCollection.doc(doc.id).update({
            //         userName: user.name
            //     })
            // })
        },
        async registraTrivia({ dispatch, commit }, data) {


            dispatch('showLoader', true)


            //localStorage.setItem('puntos', puntos)
            //localStorage.setItem('ultimo_tiempo', data.time_txt)

            await dispatch('cierraParticipacion', {
                puntos: data.puntos,
                fecha_fin: new Date(),
                time_txt: data.time_txt,
                time: data.time,
                respuestas: {},
                week: moment().week()
            })

            commit('setTicketID', '')
            commit('removeTimeInit', '')

            //dispatch('showLoader', false)

            console.log("redireccionando")

            router.push('/resultado')

        },
        async cierraParticipacion({ dispatch, commit }, data) {
            // const userId = fb.auth.currentUser.uid

            // console.log({ 'cierra participacion': this.getters.ticketID })
            //     //console.log(data)

            // data.fecha_fin = new Date()
            // data.ticketID = this.getters.ticketID

            // //fb.functions.useFunctionsEmulator('http://localhost:5001')

            // var cierraParticipacion = fb.functions.httpsCallable('cierraParticipacion');

            // await cierraParticipacion(JSON.stringify(data)).then(function(result) {
            //     // Read result of the Cloud Function.
            //     console.log({ resultadoFire: result })
            //         // ...
            // });
            // console.log('terminó guardado cierra participación')

            // //commit('setTicket', data)



        },

        async uploadImage({ dispatch }, file) {
            // File or Blob named mountains.jpg
            // console.log('cargando imagen')
            // const userId = fb.auth.currentUser.uid
            // const idImagen = uuidv4()
            // const nombreImagen = userId + '-' + idImagen + '.' + file.name.split('.').pop()

            // const storageRef = fb.storage.ref(`tickets/${nombreImagen}`).put(file)

            // let promesa = null
            // promesa = () => {
            //     return new Promise((resolve, reject) => {
            //         storageRef.on('state_changed',
            //             snapshot => {
            //                 //this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            //             }, error => {
            //                 console.log(error.message)
            //                 reject(error.message)
            //             },
            //             () => {
            //                 storageRef.snapshot.ref.getDownloadURL().then((url) => {
            //                     //console.log({ url: url })
            //                     resolve(url)
            //                         //this.picture =url;
            //                 });
            //             }
            //         )
            //     })
            // }

            // let downloadUrl = null
            // try {
            //     downloadUrl = await promesa()
            // } catch (err) {
            //     console.log(err)
            //     return null
            // }

            // console.log({ termino: downloadUrl })
            //     //dispatch('setImgUrl', downloadUrl)

            // return downloadUrl
        },
        showLoader({ commit }, val) {
            commit('showLoader', val)
        },

        async setTimeInit({ commit }) {

            // const data = {
            //     init_time: new Date(),
            //     ticketID: this.getters.ticketID
            // }

            // //fb.functions.useFunctionsEmulator('http://localhost:5001')
            // var comienzaParticipacion = fb.functions.httpsCallable('comienzaParticipacion');

            // let res = null
            // await comienzaParticipacion(JSON.stringify(data)).then(function(result) {
            //     // Read result of the Cloud Function.
            //     console.log({ resultadoFire: result })
            //     res = result;
            //     // ...
            // });
            // console.log('comienza participación')
            // console.log(res)
            // if (res.data.status == 'notok' && res.data.time_init != '') {
            //     data.init_time = new Date(res.data.time_init)
            // }

            // commit('setTimeInit', data.init_time)
        }

    }
})

export default store